import { Injectable, Injector } from '@angular/core';
import { IAttachmentSource, InveniasAttachmentSource } from 'attachment-source-lib';
import { InveniasAuthService } from 'auth-service-lib';
import { InveniasDataSourceApiService } from 'datasource-service-lib';
import { InveniasDocumentDestinationService } from 'document-destination-service-lib';
import { InveniasEntityMetadataService } from 'entity-metadata-service-lib';
import { InveniasEntityPathService } from 'entity-path-service-lib';
import { InveniasEntityPickerService } from 'entity-picker-lib';
import { InveniasFileDataSourceApiService } from 'file-datasource-service-lib';
import { InveniasIconService } from 'icon-service-lib';
import {
  IAuthService,
  IDataSourceApiService,
  IEntityMetadataService,
  IEntityPickerService,
  IEntityTypeOption,
  IFileDataSourceApiService,
  IIconService,
  ISharedServiceProviderService
} from 'interfaces-lib';
import { jwtDecode } from 'jwt-decode';
import { INamedEntityService, InveniasNamedEntityService } from 'named-entity-service-lib';
import { InveniasRecipientInfoService, IRecipientInfoService } from 'recipient-info-service-lib';
import { Observable } from 'rxjs';
import { InveniasTerminologyService, ITerminologyService } from 'terminology-lib';
import { InveniasEntityTypeMappingsService } from './invenias-entity-type-mappings.service';

@Injectable({ providedIn: 'root' })
export class InveniasSharedServiceProviderService implements ISharedServiceProviderService {
  private static readonly ENDPOINT_URL_CLAIM = 'http://www.invenias.com/claims/EndpointUrl';

  constructor(private injector: Injector) {}

  getAuthService(): IAuthService {
    return this.injector.get(InveniasAuthService);
  }

  getDataSourceApiService(): IDataSourceApiService {
    return this.injector.get(InveniasDataSourceApiService);
  }

  getEntityMetadataService(): IEntityMetadataService {
    return this.injector.get(InveniasEntityMetadataService);
  }

  getIconService(): IIconService {
    return this.injector.get(InveniasIconService);
  }

  getAttachmentSourceService(): IAttachmentSource {
    return this.injector.get(InveniasAttachmentSource);
  }

  getEntityPickerService(): IEntityPickerService {
    return this.injector.get(InveniasEntityPickerService);
  }

  getRecipientInfoService(): IRecipientInfoService {
    return this.injector.get(InveniasRecipientInfoService);
  }

  getTerminologyService(): ITerminologyService {
    return this.injector.get(InveniasTerminologyService);
  }

  getNamedEntityService(): INamedEntityService {
    return this.injector.get(InveniasNamedEntityService);
  }

  getEntityPathService() {
    return this.injector.get(InveniasEntityPathService);
  }

  getDocumentDestinationService() {
    return this.injector.get(InveniasDocumentDestinationService);
  }

  getFileDataSourceApiService(): IFileDataSourceApiService {
    return this.injector.get(InveniasFileDataSourceApiService);
  }

  getCorpId(token: string): string {
    const decoded = jwtDecode<Record<string, string>>(token);
    const endpointUrl = decoded[InveniasSharedServiceProviderService.ENDPOINT_URL_CLAIM];
    if (!endpointUrl) {
      throw new Error('EndpointUrl not found in Invenias token');
    }
    return endpointUrl.split('.')[0];
  }

  getEntityTypeOptions(parentEntityType: string): Observable<IEntityTypeOption[]> {
    return this.injector.get(InveniasEntityTypeMappingsService).getEntityTypeOptions(parentEntityType);
  }
}
